export default __webpack_public_path__ + "static/media/nft1.f9e78818.jpg";